import React, { PropsWithChildren } from 'react'
import { StyleCta, StyledContentSection, StyledDate, StyledDescription, StyledTitle } from './styledCarouselElements'

// Content section
export type ContentSectionProps = React.ComponentProps<typeof StyledContentSection> & {
  layout?: 'vertical' | 'horizontal'
}

export const ContentSection: React.FC<PropsWithChildren<ContentSectionProps>> = ({ layout, children, ...props }) => (
  <StyledContentSection {...props}
    container
    direction="column"
    justifyContent={'flex-start'}
    alignItems={'flex-start'}
  >
    {children}
  </StyledContentSection>
)

// Date
export type CarouselDateProps = React.ComponentProps<typeof StyledDate> & {
  //
}

export const CarouselDate: React.FC<PropsWithChildren<CarouselDateProps>> = ({ href, children, ...props }) => (
  <StyledDate {...props}>{children}</StyledDate>
)

// Title
export type CarouselTitleProps = React.ComponentProps<typeof StyledTitle> & {
  //
}

export const CarouselTitle: React.FC<PropsWithChildren<CarouselTitleProps>> = ({ children, ...props }) => (
  <StyledTitle {...props}>{children}</StyledTitle>
)

// Description
export type CarouselDescriptionProps = React.ComponentProps<typeof StyledDescription> & {
  //
}

export const CarouselDescription: React.FC<PropsWithChildren<CarouselDescriptionProps>> = ({ href, children, ...props }) => (
  <StyledDescription {...props}>{children}</StyledDescription>
)

// CTA
export type CarouselCtaProps = React.ComponentProps<typeof StyleCta> & {
  //
}

export const CarouselCta: React.FC<PropsWithChildren<CarouselCtaProps>> = ({ href, children, ...props }) => (
  <StyleCta href={href} {...props}>{children}</StyleCta>
)
